export var ZnifferCommand;
(function (ZnifferCommand) {
    ZnifferCommand["init"] = "zniffer.init";
    ZnifferCommand["start"] = "zniffer.start";
    ZnifferCommand["clearCapturedFrames"] = "zniffer.clear_captured_frames";
    ZnifferCommand["getCaptureAsZLFBuffer"] = "zniffer.get_capture_as_zlf_buffer";
    ZnifferCommand["capturedFrames"] = "zniffer.captured_frames";
    ZnifferCommand["stop"] = "zniffer.stop";
    ZnifferCommand["destroy"] = "zniffer.destroy";
    ZnifferCommand["supportedFrequencies"] = "zniffer.supported_frequencies";
    ZnifferCommand["currentFrequency"] = "zniffer.current_frequency";
    ZnifferCommand["setFrequency"] = "zniffer.set_frequency";
    // Undocumented
    ZnifferCommand["getLRRegions"] = "zniffer.get_lr_regions";
    // Undocumented
    ZnifferCommand["getCurrentLRChannelConfig"] = "zniffer.get_current_lr_channel_config";
    // Undocumented
    ZnifferCommand["getSupportedLRChannelConfigs"] = "zniffer.get_supported_lr_channel_configs";
    // Undocumented
    ZnifferCommand["setLRChannelConfig"] = "zniffer.set_lr_channel_config";
    ZnifferCommand["loadCaptureFromBuffer"] = "zniffer.load_capture_from_buffer";
})(ZnifferCommand || (ZnifferCommand = {}));
